/* unplugin-vue-components disabled */import script from "./UploadImageWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadImageWrapper.vue?vue&type=script&setup=true&lang=js"

import "./UploadImageWrapper.vue?vue&type=style&index=0&id=8cc4dbd2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cc4dbd2"]])

export default __exports__